<template>
    <section class="container bg-white my-5 p-5">

        <time-box v-if="belongsToCheckout" :message="timeBoxText"></time-box>

        <form method="post" :action="formAction" v-on:submit.prevent="formSubmit">
            <div class="row justify-content-center align-items-top">
                <div class="col-12">
                    <div class="container-fluid">
                        <p><b>Anrede</b></p>
                        <div class="form-group" id="salutation">
                            <div class="form-check form-check-inline">
                                <input class="form-check-input" type="radio" name="consumer[salutation]"
                                    id="salutationMr" value="MR" v-model="fields.consumer.salutation">
                                <label class="form-check-label" for="salutationMr">Herr</label>
                            </div>
                            <div class="form-check form-check-inline">
                                <input class="form-check-input" type="radio" name="consumer[salutation]"
                                    id="salutationMs" v-model="fields.consumer.salutation" value="MS">
                                <label class="form-check-label" for="salutationMs">Frau</label>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="row justify-content-center align-items-top">
                <div class="col-12 col-md-5">
                    <div class="form-row">
                        <div class="col-6 form-group">
                            <label for="first_name">Vorname *</label>
                            <input required type="text" name="consumer[first_name]" id="first_name" class="form-control"
                                placeholder="Vorname" v-on:change="validate" v-on:keyup="validate"
                                v-model="fields.consumer.first_name">
                        </div>
                        <div class="col-6 form-group">
                            <label for="last_name">Nachname *</label>
                            <input required type="text" name="consumer[last_name]" id="last_name" class="form-control"
                                placeholder="Nachname" v-on:change="validate" v-on:keyup="validate"
                                v-model="fields.consumer.last_name">
                        </div>
                    </div>
                    <div class="form-row">
                        <div class="col-12 form-group">
                            <label for="company">Firma</label>
                            <input type="text" name="address[company]" id="company" placeholder="Firma"
                                class="form-control" v-model="fields.address.company">
                        </div>
                    </div>
                    <div class="form-row">

                        <div class="col-8 form-group">
                            <label for="street">Straße *</label>
                            <input required type="text" name="address[street]" id="street" class="form-control"
                                placeholder="Straße" v-on:change="validate" v-on:keyup="validate"
                                v-model="fields.address.street">
                        </div>
                        <div class="col-4 form-group">
                            <label for="house_number">Nr. *</label>
                            <input required type="text" name="address[house_number]" id="house_number"
                                class="form-control" placeholder="Nr." v-on:change="validate" v-on:keyup="validate"
                                v-model="fields.address.house_number">
                        </div>
                        <div id="addressBlock" class="col-12">
                            <address-line v-on:newAddressLine="addAddressline"
                                v-on:removeAddressLine="removeAddressline"></address-line>
                        </div>
                    </div>

                    <div class="form-row">
                        <div class="col-4 form-group">
                            <label for="postal_code">Postleitzahl (PLZ) *</label>
                            <input required type="text" name="address[postal_code]" id="postal_code"
                                class="form-control" placeholder="Postleitzahl" v-on:change="validate"
                                v-on:keyup="validate" v-model="fields.address.postal_code">
                        </div>
                        <div class="col-8 form-group">
                            <label for="city">Ort / Stadt *</label>
                            <input required type="text" name="address[city]" id="city" class="form-control"
                                placeholder="Ort / Stadt" v-on:change="validate" v-on:keyup="validate"
                                v-model="fields.address.city">
                        </div>
                    </div>
                </div>

                <div class="col-12 col-md-6 offset-md-1">
                    <div class="form-row">
                        <div class="form-group col-6">
                            <label for="birthday">Geburtstag *</label>
                            <flat-pickr v-model="presetDate" :config="birthdayConfig" class="form-control"
                                placeholder="Geburtsdatum" name="consumer[birthday]" @on-change="validateBirthday">
                            </flat-pickr>
                        </div>

                        <div class="col-6">
                            <p>
                                <small>Wir benötigen dein Geburtsdatum für die Bonitätsprüfung, die wir routinemäßig
                                    durchführen.
                                </small>
                            </p>
                        </div>
                    </div>

                    <div class="form-row">
                        <div class="col-12 col-md-6 form-group">
                            <label for="email">E-Mail-Adresse *</label>
                            <input required v-on:keyUp="checkEmail" v-model="fields.consumer.email" type="email"
                                name="consumer[email]" id="email" class="form-control" placeholder="max@beispiel.de"
                                v-on:change="validate" v-on:keyup="validate">
                        </div>

                        <div class="col-12 col-md-6 form-group">
                            <label for="telephone">Telefonnummer *</label>
                            <input required type="tel" name="consumer[telephone]" id="telephone" class="form-control"
                                placeholder="+49123456789" v-on:change="validate" v-on:keyup="validate"
                                v-model="fields.consumer.telephone">
                        </div>
                    </div>

                    <password-field v-on:passwordIsInvalid="setPasswordAsInvalid"
                        v-on:passwordIsValid="setPasswordAsValid"
                        v-on:update:password="fields.consumer.password = $event"
                        v-on:update:passwordConfirmation="fields.consumer.password_confirmation = $event"
                        :label="'Passwort'" :id="'password'" name="'consumer[password]'"></password-field>

                </div>
            </div>

            <csrf-field :token="csrfToken" />
            <input type="hidden" v-model="fields.address.country" name="address[country]" value="DE">

            <div class="row">
                <div class="col-12">
                    <p class="form-text text-muted">Mit <b>*</b> markierte Felder sind Pflichtangaben.</p>
                    <button type="submit" class="btn btn-primary" v-if="form_valid">Weiter</button>
                    <button type="submit" class="btn btn-primary" disabled v-else>Weiter</button>
                </div>
            </div>

        </form>

    </section>
</template>

<script>
    import flatPickr from 'vue-flatpickr-component';
    import 'flatpickr/dist/flatpickr.css';
    import {German} from "flatpickr/dist/l10n/de.js";

    export default {
        name: "NewCustomerRegistration",
        props: ['csrfToken', 'formAction', 'belongsToCheckout', 'vehiclePlain', 'targetUrl', 'subscriptionPlain'],
        data() {
            return {
                timeBoxText: "Super! Wir brauchen nur noch ein paar Daten von dir. Dein Auto ist jetzt 15 Minuten reserviert,\n" +
                    "damit du deine Buchung in Ruhe abschließen kannst. Wir freuen uns auf dich!",
                subscription: "",
                vehicle: "",
                fields: {
                    consumer: {
                        salutation: "MR",
                        first_name: "",
                        last_name: "",
                        birthday: "",
                        email: "",
                        telephone: "",
                        password: "",
                        password_confirmation: ""
                    },
                    address: {
                        street: "",
                        house_number: "",
                        postal_code: "",
                        city: "",
                        country: "DE",
                        addressLines: []
                    },
                },
                birthdayConfig: {
                    wrap: true,
                    utc: true,
                    dateFormat: 'd.m.Y',
                    time_24hr: true,
                    locale: German
                },
                validation: {
                    first_name: false,
                    last_name: false,
                    salutation: true,
                    street: false,
                    house_number: false,
                    postal_code: false,
                    city: false,
                    birthday: false,
                    email: false,
                    telephone: false,
                    password: false
                },
                form_valid: false
            }
        },
        computed: {
            presetDate:{
                get(){
                    return this.getCurrentDayFromPast();
                },
                set(newValue){
                    this.fields.consumer.birthday = newValue;
                }
            }
        },
        methods: {
            formSubmit(){
                axios.post(this.formAction, {
                    consumer: this.fields.consumer,
                    address: this.fields.address,
                    subscription: this.subscription
                })
                    .then(function(response){
                        self.subscription = response.data.subscription;
                        window.location.href = response.data.nextUrl
                    })
                    .catch(function(error){
                        console.warn(error.getMessage());
                    })
            },
            addAddressline(payload){
                this.fields.address.addressLines[payload.id] = payload.value;
            },
            removeAddressline(payload){
                this.fields.address.addressLines.splice(payload, 1);
            },
            setSubscription(payload){
                this.subscription = payload;
            },
            checkEmail() {
                var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                return re.test(email);
            },
            setPasswordAsValid() {
                this.validation.password = true;
                this.enableButton();
            },
            setPasswordAsInvalid() {
                this.validation.password = false;
                this.enableButton();
            },
            setPassword(){},
            setPasswordConfirmation(){},
            validate() {
                this.validation.first_name = this.fields.consumer.first_name ? true : false;
                this.validation.last_name = this.fields.consumer.last_name ? true : false;
                this.validation.street = this.fields.address.street ? true : false;
                this.validation.house_number = this.fields.address.house_number ? true : false;
                this.validation.postal_code = this.fields.address.postal_code ? true : false;
                this.validation.city = this.fields.address.city ? true : false;
                this.validation.email = this.fields.consumer.email ? true : false;
                this.validation.telephone = this.fields.consumer.telephone ? true : false;
                this.validation.birthday = this.fields.consumer.birthday ? true : false;
                this.enableButton();
            },
            validateBirthday(date, dateStr) {
                let selectedDay = new Date(date);

                if(this.isSameDay(selectedDay, this.getCurrentDayFromPast()) || this.isOlderThan(selectedDay, this.getCurrentDayFromPast())){
                    this.validation.birthday = true;
                } else {
                    this.validation.birthday = false;
                }
                this.enableButton();
            },
            enableButton() {
                let formIsValid = true;
                $.each(this.validation, function (key, value) {
                    if (value === false) {
                        formIsValid = false;
                    }
                });
                this.form_valid = formIsValid;
            },
            getCurrentDayFromPast(){
                return new Date(new Date().setFullYear(new Date().getFullYear() - 18));
            },
            isSameDay(date1, date2){
                return date1.setHours(0,0,0,0) === date2.setHours(0,0,0,0)
            },
            isOlderThan(dateToCheck, compareDate){
                return dateToCheck.setHours(0,0,0,0) < compareDate.setHours(0,0,0,0)
            }
        },
        mounted() {
            this.subscription = JSON.parse(this.subscriptionPlain);
            this.vehicle = JSON.parse(this.vehiclePlain);
            this.fields.consumer.birthday = "30.10.2018";
            this.validate();
        },
        components: {
            flatPickr
        }
    }
</script>

<style scoped>

</style>
